export declare const server: (serv: Server, settings: Options) => void;
export declare const player: (player: Player, serv: Server) => void;
export declare const entity: (entity: Entity, serv: Server) => void;
declare global {
    interface Server {
        /** List of all plugins. Use serv.plugins[pluginName] to get a plugin's object and data. */
        "plugins": {};
    }
    interface Entity {
        /** Gets object that stores data, personalized per plugin. Returns null if plugin does not exist.
         *
         * Shortcut for: entity.pluginData[pluginName];
         */
        'getData': (pluginName: any) => any;
    }
}
